export const REDIRECTS = 'redirects/'
export const TOOLBAR = 'toolbar/'
export const TRADUZIONI = 'traduzioni/'
export const MENU = 'menu/'
export const LISTING = 'listing/'
export const LISTING_PROGETTI = 'listing-progetti/'
export const CHECK_REVALIDATE = 'check-revalidate/'
